import React from 'react';

export const FileUploaderPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { label, buttonText, accept, multiple } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      {label && <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>{label}</label>}
      <div style={{
        border: '2px dashed #D1D5DB',
        borderRadius: '8px',
        padding: '24px',
        textAlign: 'center',
        background: '#F9FAFB'
      }}>
        <button style={{
          padding: '8px 16px',
          background: '#3B82F6',
          color: '#FFFFFF',
          border: 'none',
          borderRadius: '6px',
          fontSize: '14px',
          cursor: 'pointer'
        }}>
          {buttonText || 'Choose File'}
        </button>
        <p style={{ margin: '8px 0 0', fontSize: '12px', color: '#6B7280' }}>
          {multiple ? 'Multiple files allowed' : 'Single file'} • {accept || 'All types'}
        </p>
      </div>
      </div>
    </div>
  );
};
